export default "__VITE_ASSET__JotEXfnR__"